import React from 'react';

import BigCommerceSSOComponent from '@src/views/BigCommerce/BigCommerceSSOComponent';
import PortalContainer from '@components/PortalContainer';
import Container from '@common/components/Container/Container';

const BigCommerceSSO = () => (
  <PortalContainer>
    <Container style={{ paddingBottom: '30px' }}>
      <BigCommerceSSOComponent />
    </Container>
  </PortalContainer>
);

export default BigCommerceSSO;
